/*** IMPORTS FROM imports-loader ***/

var define = false;

Drupal.behaviors.lessonDialog = {
  attach(context) {
    const BUTTONS = context.querySelectorAll("button[data-lesson-dialog]");

    BUTTONS.forEach(button => {
      button.addEventListener('click', () => {
        let ajaxSettings = {
          url: `/node/${ button.getAttribute('data-nid') }`,
          dialogType: 'modal',
          dialog: {
            width: "90vw",
            classes: {
              "ui-dialog": "modal modal--ajax",
              "ui-dialog-titlebar-close": "modal__close",
              "ui-dialog-titlebar": "modal__titlebar",
              "ui-dialog-title": "modal__title",
              "ui-dialog-content": "modal__content",
            },
          },
        };

        let myAjaxObject = Drupal.ajax(ajaxSettings);
        myAjaxObject.execute();
      });
    });

    $(window).on('dialog:aftercreate', () => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500);
    })

    window.addEventListener('resize', () => {
      const DIALOG = context.querySelector('.ui-dialog');

      if (DIALOG) {
        const DIALOG_CONTENT = DIALOG.querySelector('.ui-dialog-content');
        if (!DIALOG_CONTENT) return;

        const SCORM_PLAYER = DIALOG.querySelector('.scorm-player');
        if (!SCORM_PLAYER) return;

        SCORM_PLAYER.style.height = DIALOG_CONTENT.style['max-height'];
      }
    });
  }
}
